<template>
  <div id="penjurusan">
    <Splash v-if="isSplash == true" />
    <Landing v-if="isSplash == false" />
  </div>
</template>

<script>
import Landing from "../../components/penjurusan/Landing.vue";
import Splash from "../../components/penjurusan/Splash.vue";

export default {
  name: "penjurusan",
  components: {
    Landing,
    Splash,
  },
  data: () => ({
    isSplash: true,
  }),
  mounted() {
    setTimeout(() => {
      this.isSplash = false;
    }, 1000);
  },
};
</script>

<style>
.unselectable {
  -webkit-user-select: none;
  -webkit-touch-callout: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}
</style>
